import React from 'react';
import { DialogComponent } from '../../../../Components';
import GoogleDocIframe from '../../../../Views/Home/TemplatesView/Dialogs/TemplatesPreviewDialog/Utilities/GoogleDocIframe';
import {
  getDownloadableLink,
  getPublicDownloadableLink,
} from '../../../../Helper';
import PDFViewer from '../../../../Components/PDFViewer/PDFViewer';

function PreviewDialog({
  proposalFileId,
  onClose,
  isOpen,
  parentTranslationPath,
}) {
  if (!isOpen) return null;
  return (
    <DialogComponent
      isOpen
      onCloseClicked={onClose}
      titleText={'Preview'}
      parentTranslationPath={parentTranslationPath}
      dialogContent={
        // <GoogleDocIframe url={getPublicDownloadableLink(proposalFileId)} />
        <PDFViewer fileUrl={getPublicDownloadableLink(proposalFileId)} />
      }
    />
  );
}

export default PreviewDialog;
